export default __webpack_public_path__ + "static/media/LogoBE.f6ca5dc6.svg";